import { render } from "./ForgetPwd.vue?vue&type=template&id=2e63f561&scoped=true"
import script from "./ForgetPwd.vue?vue&type=script&lang=js"
export * from "./ForgetPwd.vue?vue&type=script&lang=js"

import "./ForgetPwd.vue?vue&type=style&index=0&id=2e63f561&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e63f561"]])

export default __exports__